<script setup lang="ts">
interface IProps {
  title?: string;
  description?: string;
}

defineProps<IProps>();
</script>

<template>
  <div class="payment-status-loader">
    <transition name="fade" mode="out-in">
      <div class="payment-status-loader__container">
        <div class="payment-status-loader-spinner">
          <div v-for="n in 8" class="payment-status-loader-spinner__stick" :style="`--i:${n};`"></div>
        </div>
        <div v-if="title || description" class="payment-status-loader__content">
          <div v-if="title" class="payment-status-loader__title" v-html="title.replace(/\n/g, '<br>')"></div>
          <div v-if="description" class="payment-status-loader__phrase" v-html="description.replace(/\n/g, '<br>')"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped lang="scss">
.payment-status-loader {
  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.75rem;
    max-width: 287px;
  }

  &__title {
    @include text(20px, 700, var(--brown1), 120%);
    margin-top: 4px;
    margin-bottom: 8px;
    text-align: center;
  }

  &__phrase {
    @include text(16px, 400, var(--grey2), 120%);
    text-align: center;
  }
}

.payment-status-loader-spinner {
  --size: 80px;
  --animation-time: 1.6s;
  --animation-delay: calc(var(--animation-time) / 8);
  position: relative;
  width: var(--size);
  height: var(--size);

  &__stick {
    transform-origin: calc(var(--size) / 2) calc(var(--size) / 2);
    transform: rotate(calc(45deg * var(--i)));
    animation: spinner var(--animation-time) linear infinite;
    animation-delay: calc(var(--i) * var(--animation-delay) - var(--animation-time));

    &::after {
      content: " ";
      position: absolute;
      top: 3.2px;
      left: 36.8px;
      width: 6.67px;
      height: 16.67px;
      border-radius: 6.67px;
      background-color: #007AFF;
    }
  }

  @keyframes spinner {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0.1;
    }
  }
}
</style>
